import { useEffect } from 'react';

import { useCashIncome } from '../../hooks/cash/useCashIncome';
import { useCashSession } from '../../hooks/cash/useCashSession';

import CashSessionHeader from '../CashStatus/CashSessionHeader';
import CashSessionStats from '../CashStatus/CashSessionStats';
import CashSessionFooter from '../CashStatus/CashSessionFooter';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';

const CashIncomeSessionCard = () => {
  const { open } = useCashIncome();
  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  if (!activeSession) {
    return (
      <EmptyCashSessionState/>
    );
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <CashSessionHeader
        onAction={open}
        actionLabel="Nuevo Ingreso"
        actionColor="#16a34a"
      />

      <CashSessionStats
        registerName={activeSession.registerName}
        userName={activeSession.openedByName}
        openingTime={activeSession.openedAt}
      />

      <CashSessionFooter currentBalance={activeSession.currentBalance} />
    </div>
  );
};

export default CashIncomeSessionCard;
